export default "__VITE_ASSET__BDTR0k7V__"